import {BoxProps} from '@chakra-ui/react';
import React, {memo, useRef, useState} from 'react';
import {Col, Row, UiBox, UiImage, UiText} from '~/components/elements';
import {HowItWorks} from '~/types/models/questionnaire';

interface Props extends BoxProps {
  data: HowItWorks[];
  heightScrollDivider?: number;
}

export const VerticalImageList = memo(function VerticalImageList({data, heightScrollDivider = 2, ...rest}: Props) {
  const [isLastItemVisible, setIsLastItemVisible] = useState(false);
  const lastItemRef = useRef<any>(null);

  const checkIfLastItemVisible = () => {
    const lastItem = lastItemRef.current;
    if (lastItem) {
      const rect = lastItem.getBoundingClientRect();
      setIsLastItemVisible(rect.top <= window.innerHeight / heightScrollDivider && rect.bottom >= 0);
    }
  };

  return (
    <UiBox position="relative" w={{base: '100%', md: '80%'}} {...rest}>
      <Col maxH="40vh" overflowY="scroll" onScroll={checkIfLastItemVisible}>
        {data.map((item, index) => (
          <Row key={item.title} flex={1} py={3}>
            <Col justifyContent="center" mr={4}>
              {/* <UiImage boxSize={20} url={item?.image} borderRadius={1.5} /> */}
              <img
                src={item?.image}
                alt={item?.title}
                style={{width: '5rem', height: '5rem', borderRadius: '0.375rem', maxWidth: 'none', objectFit: 'cover'}}
              />
            </Col>
            <Col maxW={{base: '15rem', sm: '100%'}} flexGrow={1} alignItems="start" textAlign="left">
              <UiText ref={index === data.length - 1 ? lastItemRef : null} fontWeight="700" fontSize="md" mb={2}>
                {item?.title}
              </UiText>
              <UiText fontSize="xs">{item?.description}</UiText>
            </Col>
          </Row>
        ))}
      </Col>
      {!isLastItemVisible && (
        <UiBox
          position="absolute"
          bottom={0}
          left={0}
          right={0}
          h="30%"
          bg="linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, #FFF 100%)"
        />
      )}
    </UiBox>
  );
});
